<section class="flex flex-col gap-3 relative">
  <div
    swiper
    (init)="swiper = $event"
    [options]="swiperOptions"
    (realIndex)="swiperIndex.set($event)"
    class="overflow-hidden h-[18rem]"
  >
    <div class="swiper-wrapper flex h-full">
      @for (image of imageUrls(); track $index) {
        <img
          (load)="onImageLoad($event)"
          class="swiper-slide h-full object-contain"
          [src]="image"
        />
      }
    </div>
  </div>
  @if (!hiddenIndex()) {
    <div
      class="absolute z-20 bottom-3 left-1/2 transform -translate-x-1/2 bg-[#1F2937CC] bg-opacity-80 text-sm rounded-xl min-w-max h-fit max-w-max flex items-center px-2 py-1 gap-0.5"
    >
      <p class="text-white">{{ swiperIndex() + 1 || 0 }} /</p>
      <p class="text-gray-300">{{ imageUrls().length || 0 }}</p>
    </div>
  }
</section>
